import {
  Box,
  Flex,
  Text,
  Modal,
  ModalContent,
  ModalOverlay,
  Image,
  Button,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useState, memo, useEffect } from "react";
import IconX from "../../../assets/images/booking/x-circle.svg";
import IconCheck from "../../../assets/images/booking/check-circle.svg";
import IconRed from "../../../assets/images/booking/x-red.svg";
import { bookingImageCall } from "../../../api/bookingImage";
import { bookingCall } from "../../../api/booking";
import toast from "react-hot-toast";
import { bookingHistoryCall } from "../../../api/bookingHistory";
import { formatDateDb } from "../../../utils/tools";
import PopupProjectManagementTitle from "../../../components/popup/popupProjectManagementTitle";
import PopupApartmentInfo from "../../../components/popup/popupApartment";
import FormInfoBusiness from "../../customers/formCustomers/formInfoBusiness";
import FormInfoCustomer from "../../customers/formCustomers/formInfo";
import FormInfoEmployee from "../../../components/form/formInfo";
import { formatNumber } from "../../../utils/utils";
import PopupBookingEvent from "../../../components/popup/popupBookingEvent";
import ImagePreviewZoom from "../../../components/ImagePreviewZoom";
const baseURL = process.env.REACT_APP_BACKEND_API || "http://localhost:3001";

const FormInfo = memo(({ isOpen, onClose, value, refetch, idData }) => {
  const [historyBooking, setHistoryBooking] = useState(null);
  const {
    isOpen: isOpenProject,
    onOpen: onOpenProject,
    onClose: onCloseProject,
  } = useDisclosure();
  const {
    isOpen: isOpenApartment,
    onOpen: onOpenApartment,
    onClose: onCloseApartment,
  } = useDisclosure();
  const {
    isOpen: isOpenCustomer,
    onOpen: onOpenCustomer,
    onClose: onCloseCustomer,
  } = useDisclosure();
  const {
    isOpen: isOpenBookingEvent,
    onOpen: onOpenBookingEvent,
    onClose: onCloseBookingEvent,
  } = useDisclosure();
  const {
    isOpen: isOpenEmployee,
    onOpen: onOpenEmployee,
    onClose: onCloseEmployee,
  } = useDisclosure();
  const {
    isOpen: isOpenApproved,
    onOpen: onOpenApproved,
    onClose: onCloseApproved,
  } = useDisclosure();

  const [defaultValues, setDefaultValues] = useState(value);

  useEffect(() => {
    if (idData) {
      const fetchData = async () => {
        try {
          const projectManager = await bookingCall.getId(idData);
          if (projectManager) {
            setDefaultValues(projectManager || []);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      fetchData();
    }

    if (value) {
      setDefaultValues(value);
    }
  }, [idData, value]);

  useEffect(() => {
    if (defaultValues?.id) {
      if (
        defaultValues?.status === "APPROVED" ||
        defaultValues?.status === "REJECTED"
      ) {
        const fetchDataBookingHistory = async () => {
          try {
            const data = await bookingHistoryCall.getHistoryBooking(
              defaultValues?.id,
            );

            setHistoryBooking(null);
            if (data?.items) {
              setHistoryBooking(data?.items[0]);
            }
          } catch (error) {
            console.error("Error fetching data:", error);
          }
        };
        fetchDataBookingHistory();
      }
    }
  }, [isOpen]);

  const submitStatus = async (status) => {
    const toastEdit = toast.loading("Đang cập nhập trạng thái ...");
    const dataFormat = {
      status: status,
    };

    try {
      await bookingCall.approve(defaultValues?.id, dataFormat);
      refetch();
      onClose();
      toast.success("Cập nhập trạng thái thành công");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Có lỗi xảy ra khi cập nhập trạng thái");
    }
    toast.dismiss(toastEdit);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        backgroundColor="var(--color-main)"
        borderRadius={"16px"}
        position={"relative"}
        w={"100%"}
        maxW={"625px"}
      >
        <Box
          paddingBottom={"80px"}
          h={"86.5vh"}
          w={"100%"}
          overflowY={"auto"}
          sx={{
            "&::-webkit-scrollbar": {
              width: "4px",
            },
            "&::-webkit-scrollbar-thumb": {
              width: "4px",
              borderRadius: "50px",
              background: "var(--color-background)",
            },
            "&::-moz-scrollbar": {
              width: "4px",
            },
            "&::-moz-scrollbar-thumb": {
              width: "4px",
              borderRadius: "50px",
              background: "var(--color-background)",
            },
          }}
        >
          <Flex
            alignItems={"center"}
            p={"25px 24px 24px 24px"}
            position={"relative"}
            borderBottom={
              defaultValues?.status === "APPROVED" ||
              defaultValues?.status === "REJECTED"
                ? ""
                : "1px solid var(--border-input-employee)"
            }
          >
            <Text
              color={"var(--color-header-employee)"}
              fontSize={"16px"}
              fontWeight={"600"}
            >
              Chi tiết đợt Booking
            </Text>
            <Box
              position={"absolute"}
              top={"24px"}
              right={"24px"}
              cursor={"pointer"}
              onClick={onClose}
            >
              <Image src={IconX} />
            </Box>
          </Flex>
          {(defaultValues?.status === "APPROVED" ||
            defaultValues?.status === "REJECTED") && (
            <Flex
              p={"16px 24px"}
              justifyContent={"space-between"}
              bg={
                defaultValues?.status === "APPROVED"
                  ? "var(--bg-green-1)"
                  : "var(--bg-red-1)"
              }
            >
              {defaultValues?.status === "APPROVED" && (
                <Flex
                  p={"12px"}
                  justifyContent={"space-between"}
                  gap={"8px"}
                  bg={"var(--bg-status-success)"}
                  borderRadius={"8px"}
                  w={"max-content"}
                  minW={"151px"}
                  h={"max-content"}
                >
                  <Image
                    src={IconCheck}
                    w={"20px"}
                    h={"20px"}
                    objectFit={"cover"}
                  />
                  <Text
                    fontSize={"14px"}
                    lineHeight={"20px"}
                    fontWeight={500}
                    color={"var(--color-status-employ)"}
                    display={"block"}
                  >
                    Đã được duyệt
                  </Text>
                </Flex>
              )}
              {defaultValues?.status === "REJECTED" && (
                <Flex
                  p={"12px"}
                  justifyContent={"space-between"}
                  gap={"8px"}
                  bg={"var(--bg-status-error)"}
                  borderRadius={"8px"}
                  w={"max-content"}
                  minW={"176px"}
                  h={"max-content"}
                >
                  <Image
                    src={IconRed}
                    w={"20px"}
                    h={"20px"}
                    objectFit={"cover"}
                  />
                  <Text
                    fontSize={"14px"}
                    lineHeight={"20px"}
                    fontWeight={500}
                    color={"var(--text-red-employee)"}
                    display={"block"}
                  >
                    Không được duyệt
                  </Text>
                </Flex>
              )}

              <Flex gap={"40px"}>
                <Box textAlign={"end"}>
                  <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                    Người phê duyệt
                  </Text>
                  <Text
                    color={"var(--color-option-employee-hover)"}
                    textDecoration={"underline"}
                    lineHeight={"28px"}
                    cursor={"pointer"}
                    fontSize={"14px"}
                    fontWeight={"500"}
                    mt={"8px"}
                    onClick={() => onOpenApproved()}
                  >
                    {historyBooking?.approver?.fullName}
                  </Text>
                </Box>
                <Box textAlign={"end"}>
                  <Text color={"var(--color-label-employee)"} fontSize={"12px"}>
                    Thời gian duyệt
                  </Text>
                  <Text
                    color={"var(--color-option-employee)"}
                    fontSize={"14px"}
                    fontWeight={"500"}
                    mt={"8px"}
                  >
                    {historyBooking?.createdAt
                      ? formatDateDb(historyBooking?.createdAt)
                      : ""}
                  </Text>
                </Box>
              </Flex>
            </Flex>
          )}
          <Box
            paddingTop={"24px"}
            paddingBottom={"41px"}
            maxW={"545px"}
            margin={"0 auto"}
          >
            <Box>
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"16px"}
                fontWeight={"600"}
              >
                {defaultValues?.note || "Thông tin chung đợt booking"}
              </Text>
              <Box
                background={"var(--fill-avatar)"}
                p={"16px 24px 16px 16px"}
                mt={"13px"}
                borderRadius={"8px"}
              >
                {defaultValues?.bookingEvent && (
                  <Flex gap={"27px"} mb={"16px"}>
                    <Box flex={"1"}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        Đợt nhận booking
                      </Text>
                      <Text
                        color={"var(--color-option-employee-hover)"}
                        textDecoration={"underline"}
                        lineHeight={"28px"}
                        cursor={"pointer"}
                        fontSize={"14px"}
                        fontWeight={"500"}
                        mt={"8px"}
                        onClick={() => onOpenBookingEvent()}
                      >
                        {defaultValues?.bookingEvent?.name ||
                          defaultValues?.bookingEvent ||
                          ""}
                      </Text>
                    </Box>
                  </Flex>
                )}

                <Flex gap={"27px"}>
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Người tạo booking
                    </Text>
                    <Text
                      color={"var(--color-option-employee)"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      mt={"8px"}
                    >
                      {defaultValues?.bookerObject?.fullName ||
                        defaultValues?.nameBooker ||
                        ""}
                    </Text>
                  </Box>
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Ngày tạo booking
                    </Text>
                    <Text
                      color={"var(--color-option-employee)"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      mt={"8px"}
                    >
                      {defaultValues?.createdAt
                        ? formatDateDb(defaultValues?.createdAt)
                        : ""}
                    </Text>
                  </Box>
                </Flex>
                <Flex mt={"16px"} gap={"27px"}>
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Dự án
                    </Text>
                    <Text
                      color={"var(--color-option-employee-hover)"}
                      textDecoration={"underline"}
                      lineHeight={"28px"}
                      cursor={"pointer"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      mt={"8px"}
                      onClick={() => onOpenProject()}
                    >
                      {defaultValues?.project?.name ||
                        defaultValues?.projectName ||
                        ""}
                    </Text>
                  </Box>
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Sản phẩm
                    </Text>
                    <Text
                      color={"var(--color-option-employee-hover)"}
                      textDecoration={"underline"}
                      lineHeight={"28px"}
                      cursor={"pointer"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      mt={"8px"}
                      onClick={() => onOpenApartment()}
                    >
                      {`${
                        defaultValues?.apartment?.code ||
                        defaultValues?.apartmentCode ||
                        ""
                      } ${
                        defaultValues?.apartmentName ||
                        defaultValues?.apartment?.name
                          ? `(${
                              defaultValues?.apartmentName ||
                              defaultValues?.apartment?.name
                            })`
                          : ""
                      }`}
                    </Text>
                  </Box>
                </Flex>
                <Flex mt={"16px"} gap={"27px"}>
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Số tiền booking
                    </Text>
                    <Text
                      color={"var(--color-option-employee)"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      mt={"8px"}
                    >
                      {defaultValues?.price
                        ? `${formatNumber(defaultValues?.price)} VNĐ`
                        : ""}
                    </Text>
                  </Box>
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Ngày booking
                    </Text>
                    <Text
                      color={"var(--color-option-employee)"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      mt={"8px"}
                    >
                      {defaultValues?.bookingTime
                        ? formatDateDb(defaultValues?.bookingTime)
                        : ""}
                    </Text>
                  </Box>
                </Flex>
                {(defaultValues?.agentName || defaultValues?.agent?.name) && (
                  <Flex mt={"16px"} gap={"27px"}>
                    <Box flex={"1"}>
                      <Text
                        color={"var(--color-label-employee)"}
                        fontSize={"12px"}
                      >
                        Đại lý
                      </Text>
                      <Text
                        color={"var(--color-option-employee)"}
                        fontSize={"14px"}
                        fontWeight={"500"}
                        mt={"8px"}
                      >
                        {defaultValues?.agent?.name ||
                          defaultValues?.agentName ||
                          ""}
                      </Text>
                    </Box>
                  </Flex>
                )}
              </Box>
            </Box>
            <Box mt={"20px"}>
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"16px"}
                fontWeight={"600"}
              >
                Thông tin khách hàng
              </Text>
              <Box
                background={"var(--fill-avatar)"}
                p={"16px 24px 16px 16px"}
                mt={"16px"}
                borderRadius={"8px"}
              >
                <Flex gap={"27px"}>
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Tên khách hàng
                    </Text>
                    <Text
                      color={"var(--color-option-employee-hover)"}
                      textDecoration={"underline"}
                      lineHeight={"28px"}
                      cursor={"pointer"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      mt={"8px"}
                      onClick={() => onOpenCustomer()}
                    >
                      {defaultValues?.customer?.name ||
                        defaultValues?.customerName ||
                        ""}
                    </Text>
                  </Box>
                </Flex>
              </Box>
            </Box>
            <Box mt={"16px"}>
              <Flex flexDirection={"column"}>
                {defaultValues?.images && defaultValues?.images?.length > 0 && (
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Ảnh ủy nhiệm chi
                    </Text>
                    {defaultValues?.images?.map((item, index) => (
                      <Flex
                        key={index}
                        mt={"8px"}
                        border={"0.5px solid var(--bg-line-employee)"}
                        borderRadius={"8px"}
                        justifyContent={"center"}
                      >
                        <Box borderRadius={"11px"} w={"202px"} h={"300px"}>
                          {item && (
                            <ImagePreviewZoom
                              src={`${baseURL}/${item?.path}`}
                              alt={`anh-uy-nhiem-chi-${index + 1}`}
                              previewTitle={`Ảnh ủy nhiệm chi ${index + 1}`}
                            >
                              <Image
                                borderRadius={"11px"}
                                w={"100%"}
                                h={"100%"}
                                objectFit={"cover"}
                                src={`${baseURL}/${item?.path}`}
                              />
                            </ImagePreviewZoom>
                          )}
                        </Box>
                      </Flex>
                    ))}
                  </Box>
                )}
              </Flex>
            </Box>

            {/*  */}
            <Box mt={"20px"}>
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"16px"}
                fontWeight={"600"}
              >
                Thông tin nhân viên tạo
              </Text>
              <Box
                background={"var(--fill-avatar)"}
                p={"16px 24px 16px 16px"}
                mt={"16px"}
                borderRadius={"8px"}
              >
                <Flex gap={"27px"}>
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Họ tên
                    </Text>
                    <Text
                      color={"var(--color-option-employee-hover)"}
                      textDecoration={"underline"}
                      lineHeight={"28px"}
                      cursor={"pointer"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      mt={"8px"}
                      onClick={() => onOpenEmployee()}
                    >
                      {defaultValues?.bookerObject?.name ||
                        defaultValues?.nameBooker ||
                        "-"}
                    </Text>
                  </Box>
                </Flex>
                <Flex gap={"27px"} mt={"16px"}>
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Khối
                    </Text>
                    <Text
                      color={"var(--color-option-employee)"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      mt={"8px"}
                    >
                      {defaultValues?.saleBlock?.name ||
                        defaultValues?.saleBlock ||
                        "-"}
                    </Text>
                  </Box>
                  <Box flex={"1"}>
                    <Text
                      color={"var(--color-label-employee)"}
                      fontSize={"12px"}
                    >
                      Vùng
                    </Text>
                    <Text
                      color={"var(--color-option-employee)"}
                      fontSize={"14px"}
                      fontWeight={"500"}
                      mt={"8px"}
                    >
                      {defaultValues?.saleArea?.name ||
                        defaultValues?.saleArea ||
                        "-"}
                    </Text>
                  </Box>
                </Flex>
              </Box>
            </Box>
          </Box>
          <Box
            position={"absolute"}
            w={"100%"}
            bottom={"0"}
            bg={"var(--color-main)"}
            borderTop={"0.5px solid var(--bg-line-employee)"}
            borderRadius={"0px 0px 16px 16px"}
          >
            {(defaultValues?.status === "NEW" ||
              defaultValues?.status === "EDITING") && (
              <Flex p={"24px"} gap={"16px"} justifyContent={"flex-end"}>
                <Button
                  p={"13px 20px"}
                  fontSize={"15px"}
                  fontWeight={600}
                  color={"var(--color-option-employee-hover)"}
                  borderRadius={"8px"}
                  border={"1px solid var(--color-option-employee-hover)"}
                  bg={"var(--color-main)"}
                  onClick={() => submitStatus("REJECTED")}
                  _hover={{
                    filter: "brightness(90%)",
                  }}
                >
                  Không duyệt
                </Button>
                <Button
                  w={"133px"}
                  p={"13px 20px"}
                  fontSize={"15px"}
                  fontWeight={600}
                  color={"var(--color-main)"}
                  borderRadius={"8px"}
                  bg={"var(--color-option-employee-hover)"}
                  onClick={() => submitStatus("APPROVED")}
                  _hover={{
                    filter: "brightness(90%)",
                  }}
                >
                  Duyệt
                </Button>
              </Flex>
            )}
          </Box>
        </Box>
        <PopupProjectManagementTitle
          isOpen={isOpenProject}
          onClose={onCloseProject}
          defaultValue={[]}
          idData={defaultValues?.projectId}
        />
        <PopupApartmentInfo
          isOpen={isOpenApartment}
          onClose={onCloseApartment}
          defaultValue={[]}
          idData={defaultValues?.apartmentId}
        />
        {defaultValues?.customer?.isBusiness ? (
          <FormInfoBusiness
            isOpen={isOpenCustomer}
            onClose={onCloseCustomer}
            defaultValue={[]}
            idData={defaultValues?.customerId}
          />
        ) : (
          <FormInfoCustomer
            isOpen={isOpenCustomer}
            onClose={onCloseCustomer}
            defaultValue={[]}
            idData={defaultValues?.customerId}
          />
        )}
        <PopupBookingEvent
          isOpen={isOpenBookingEvent}
          onClose={onCloseBookingEvent}
          defaultValue={[]}
          idData={defaultValues?.bookingEventId}
        />
        <FormInfoEmployee
          isOpen={isOpenEmployee}
          onClose={onCloseEmployee}
          defaultValues={[]}
          idData={defaultValues?.bookerId}
        />
        <FormInfoEmployee
          isOpen={isOpenApproved}
          onClose={onCloseApproved}
          defaultValues={[]}
          idData={historyBooking?.approverId}
        />
      </ModalContent>
    </Modal>
  );
});

export default FormInfo;
